/**
 * App routing module
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2024 Build Centrix
 */
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';

@NgModule({
  declarations: [],
  exports: [RouterModule],
  imports: [
    RouterModule.forRoot(
      [
        { path: '', redirectTo: '/login', pathMatch: 'full' },
        {
          path: 'login',
          canActivate: [AuthGuard],
          loadChildren: () =>
            import(`./pages/login/login.module`).then((m) => m.LoginModule),
        },
        {
          path: 'password',
          canActivate: [AuthGuard],
          loadChildren: () =>
            import(`./pages/password/password.module`).then(
              (m) => m.PasswordModule,
            ),
        },
        {
          path: 'errors',
          loadChildren: () =>
            import(`./pages/errors/errors.module`).then((m) => m.ErrorsModule),
        },
        { path: '**', redirectTo: '/login' },
      ],
      {},
    ),
  ],
})
export class AppRoutingModule {}

// EOF
